module.exports = __webpack_public_path__ + "img/intra_oral.9fbabc01.png";